import {DuplicatedOrderError} from "@app/core/cart/domain/duplicated-order-error";
import {InfrastructureError, InfrastructureErrorType} from "@app/core/shared/domain/infrastructure.error";

/**
 * Mapper to deserialize the errors that appear in the cart's "errors" field.
 */
export class CartErrorMapper {
    static deserialize(param: any): InfrastructureError {
        if(param.key === 'ORDER') {
            return new DuplicatedOrderError(param.description);
        }

        return new InfrastructureError(InfrastructureErrorType.BackendError, null, `${param.description} ${param.value ?? ''}`);
    }
}